/* Shipping protection pricing and cart lifecycle. All amounts are integer minor units. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.OwnedProtectionCore = factory();
})(typeof window === 'object' ? window : this, function () {
  'use strict';
  function isTrackingOnlyUpdate(body) {
    if (typeof body !== 'string') return false;
    try {
      const value = JSON.parse(body);
      if (!value || Object.keys(value).length !== 1 || !value.attributes || Array.isArray(value.attributes)) return false;
      const names = Object.keys(value.attributes);
      const known = ['_scc_v','_scc_ts','_scc_ft','_scc_lp','_scc_ref','_scc_slp','_scc_sref','_scc_vid','_scc_ga','_scc_gas','_scc_gan','_scc_fbp','_scc_consent','_scc_uetvid'];
      return names.length > 0 && names.every(name => known.includes(name));
    } catch (_) { return false; }
  }
  function isProtection(item, config) {
    return config.productIds.some(id => String(id) === String(item.product_id));
  }
  function quote(cart, config) {
    const merchandise = cart.items.filter(item => !isProtection(item, config));
    if (!merchandise.length) return null;
    const total = Number.isFinite(cart.total_price)
      ? Math.max(0, cart.total_price - cart.items.filter(item => isProtection(item, config)).reduce((sum, item) => sum + item.final_line_price, 0))
      : merchandise.reduce((sum, item) => sum + item.final_line_price, 0);
    const variants = config.variants.filter(v => v.available !== false).slice().sort((a, b) => a.price - b.price);
    if (!variants.length) throw new Error('L’assurance livraison est indisponible. Veuillez réessayer.');
    const required = Math.ceil(total * config.rate / 100);
    return variants.find(v => v.price >= required) || variants[variants.length - 1];
  }
  function createController(config, api) {
    let queue = Promise.resolve();
    let checkoutPromise;
    function serialize(operation) {
      const result = queue.then(operation);
      queue = result.catch(() => {});
      return result;
    }
    async function clean() {
      let cart = await api.read();
      const keys = cart.items.filter(item => isProtection(item, config)).map(item => item.key);
      if (keys.length) cart = await api.remove(keys);
      return cart;
    }
    return {
      invalidateCheckout() { checkoutPromise = undefined; },
      browse() {
        checkoutPromise = undefined;
        return serialize(async () => {
          const cart = await clean();
          return {cart, quote: quote(cart, config)};
        });
      },
      checkout(enabled, cachedCart) {
        if (checkoutPromise) return checkoutPromise;
        checkoutPromise = serialize(async () => {
          if (api.setProtection) {
            let cart = cachedCart || await api.read();
            for (let attempt = 0; attempt < 2; attempt++) {
              const selected = enabled ? quote(cart, config) : null;
              cart = await api.setProtection(selected?.id, cart);
              const current = enabled ? quote(cart, config) : null;
              const insurance = cart.items.filter(item => isProtection(item, config));
              if (current ? insurance.length === 1 && String(insurance[0].variant_id) === String(current.id) && insurance[0].quantity === 1 : insurance.length === 0) {
                return {cart, quote: current};
              }
            }
            throw new Error('Votre panier a changé. Veuillez réessayer de passer au paiement.');
          }
          const cart = await clean();
          const selected = enabled ? quote(cart, config) : null;
          if (selected) await api.add(selected.id);
          return {cart, quote: selected};
        }).catch(error => { checkoutPromise = undefined; throw error; });
        return checkoutPromise;
      }
    };
  }
  return {quote, isProtection, createController, isTrackingOnlyUpdate};
});
